'use strict';

var tslib = require('tslib');
var React = require('react');
var superEllipse = require('@alfalab/core-components/icon-view/super-ellipse');
var vars = require('@alfalab/core-components/vars');
var ExclamationMIcon = require('@alfalab/icons-glyph/ExclamationMIcon');
var core_statusScreen_statusScreen = require('../../status-screen.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var StatusScreenWarning = function (_a) {
    var restProps = tslib.__rest(_a, []);
    var topAddon = (React__default.default.createElement(superEllipse.SuperEllipse, { backgroundColor: vars.colorLightGraphicAttention },
        React__default.default.createElement(ExclamationMIcon.ExclamationMIcon, { color: vars.colorDarkGraphicPrimary })));
    return React__default.default.createElement(core_statusScreen_statusScreen.StatusScreen, tslib.__assign({ topAddons: topAddon }, restProps));
};

exports.StatusScreenWarning = StatusScreenWarning;
